import React from "react";
import EditableSpan from "../../common/EditableSpan";

interface Errors {
  personalizationName?: boolean;
  personalizationCountry?: boolean;
  personalizationWorkingOn?: boolean;
  personalizationMustImprove?: boolean;
}

interface Props {
  title: string;
  buttonLabel: string;
  loading: boolean;
  isButtonDisabled: boolean;
  buttonClassName: string;
  personalizationName: string;
  personalizationCountry: string;
  personalizationWorkingOn: string;
  personalizationMustImprove: string;
  errors: Errors;
  onSubmit: () => void;
  onFieldChange: (
    field:
      | "personalizationName"
      | "personalizationCountry"
      | "personalizationWorkingOn"
      | "personalizationMustImprove",
    value: string,
  ) => void;
}

export const PersonalizationModalContent = ({
  title,
  buttonLabel,
  loading,
  isButtonDisabled,
  buttonClassName,
  personalizationName,
  personalizationCountry,
  personalizationWorkingOn,
  personalizationMustImprove,
  errors,
  onSubmit,
  onFieldChange,
}: Props) => (
  <>
    <h2>{title}</h2>

    <p className="pz-sub">
      Tell <strong>Deep Thought AI</strong> how to tailor your course content to
      you. The more you share, the more accurate and helpful it will be.
    </p>

    {loading && (
      <div className="ui placeholder" style={{ marginBottom: 30 }}>
        <div className="paragraph">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    )}

    {!loading && (
      <p className="pz-madlib">
        I'm{" "}
        <EditableSpan
          placeholder="your marvellous name"
          value={personalizationName}
          onChange={(value) => onFieldChange("personalizationName", value)}
          className={`pz-blank ${errors.personalizationName ? "error" : ""}`}
        />{" "}
        from{" "}
        <EditableSpan
          placeholder="country"
          value={personalizationCountry}
          onChange={(value) => onFieldChange("personalizationCountry", value)}
          className={`pz-blank ${errors.personalizationCountry ? "error" : ""}`}
        />
        . I'm currently{" "}
        <EditableSpan
          placeholder="role / company / what you're working on"
          value={personalizationWorkingOn}
          onChange={(value) => onFieldChange("personalizationWorkingOn", value)}
          className={`pz-blank ${
            errors.personalizationWorkingOn ? "error" : ""
          }`}
        />{" "}
        and I'm here to level up my skills in{" "}
        <EditableSpan
          placeholder="specific skills or future ambitions, feel free to think big"
          value={personalizationMustImprove}
          onChange={(value) =>
            onFieldChange("personalizationMustImprove", value)
          }
          className={`pz-blank ${
            errors.personalizationMustImprove ? "error" : ""
          }`}
        />
        .
      </p>
    )}

    <div className="pz-actions">
      <button
        className={buttonClassName}
        onClick={onSubmit}
        disabled={isButtonDisabled}
        type="button"
      >
        {buttonLabel} <span aria-hidden="true">&#10024;</span>
      </button>
    </div>
  </>
);
